module.exports = __webpack_public_path__ + "img/Car_of_the_month_FR.15e0f68e.jpg";